import { RouteComponentProps, Router } from '@gatsbyjs/reach-router'
import { APExpanded } from 'ap-components'
import React from 'react'
import { AutoPayInstruction } from './AutoPayInstruction'
import CancelSetup from './CancelSetup'
import FakeDigioLink from './FakeDigioLink'
import LoadingTimer from './LoadingTimer'
import OfflineInstructions from './OfflineInstructions'
import ReviewMandateDetails from './ReviewMandateDetails'
import SetupComplete from './SetupComplete'
import UpiMandateLoadingTimer from './UpiPaymentReviewPage'

export default function SingleMandateRoutes(props: RouteComponentProps) {
    return (
        <APExpanded>
            <Router style={{ display: "flex", height: "100%" }}>
                <AutoPayInstruction path="info" />
                <ReviewMandateDetails path="review" />
                <OfflineInstructions path="instructions/offline" />
                <SetupComplete path="complete/:type" />
                <CancelSetup path="failure" />
                <LoadingTimer path="paymentlink" />
                <FakeDigioLink path="digio" />
                <UpiMandateLoadingTimer path='upiInstruction' />
                <SetupComplete path="success" />
                {/* <Loader /> */}
                {/* <OnlineAutoPay /> */}
                {/* <PartnerCreatesAutopay /> */}
                {/* <CancelSetup /> */}
                {/* <SetupComplete /> */}
                {/* <Timer /> */}
            </Router>
        </APExpanded>
    )
}